import React from 'react';
import styled from '@emotion/styled';
import { Globe, Smartphone, Monitor, Palette, PenTool, Database } from '../Shared/Icons';
import { useLang } from '../../context/LanguageContext';
import { t } from '../../translations';

const ICONS = [Globe, Smartphone, Monitor, Palette, PenTool, Database];

const Section = styled.section`
  background: #F8F8F8;
  padding: 100px 50px;

  @media (max-width: 640px) {
    padding: 64px 20px;
  }
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  margin-bottom: 64px;
  text-align: center;

  @media (max-width: 640px) {
    text-align: left;
  }
`;

const Label = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #D97757;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0 0 16px;
`;

const Title = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: clamp(28px, 4vw, 48px);
  font-weight: 700;
  color: #0A0A0A;
  letter-spacing: -1px;
  line-height: 1.15;
  max-width: 560px;
  margin: 0 auto 16px;

  @media (max-width: 640px) {
    margin: 0 0 16px;
  }
`;

const Subtitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #666;
  line-height: 1.7;
  max-width: 480px;
  margin: 0 auto;

  @media (max-width: 640px) {
    margin: 0;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  border-radius: 16px;
  padding: 36px 32px;
  cursor: default;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  transition: border-color 250ms ease, box-shadow 250ms ease;

  &:hover {
    border-color: #D8D8D8;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  }
`;

const IconBox = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(217, 119, 87, 0.1);
  border: 1px solid rgba(217, 119, 87, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #D97757;
`;

const CardTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #0A0A0A;
  margin: 0 0 10px;
`;

const CardDesc = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #666;
  line-height: 1.65;
  margin: 0;
`;

const ShortServices = () => {
  const { lang } = useLang();
  const tr = t[lang].services;

  return (
    <Section id="services">
      <Container>
        <SectionHeader>
          <Label>{tr.label}</Label>
          <Title>{tr.title}</Title>
          <Subtitle>{tr.subtitle}</Subtitle>
        </SectionHeader>
        <Grid>
          {tr.items.map((service, i) => {
            const Icon = ICONS[i];
            return (
              <Card key={service.title}>
                <IconBox><Icon /></IconBox>
                <CardTitle>{service.title}</CardTitle>
                <CardDesc>{service.desc}</CardDesc>
              </Card>
            );
          })}
        </Grid>
      </Container>
    </Section>
  );
};

export default ShortServices;
